<template>
<div class="chapter">
<div class="inner_page">
<a id="page_viii"></a>
<h2 class="fmtitle"><span class="bold">Timeline</span></h2>
<table class="table">
<tbody><tr>
<td class="tab">1000 –</td>
<td class="tab1">Indicative year of the birth of Amaury I, the first lord of Montfort</td>
</tr>
<tr>
<td class="tab">1087 –</td>
<td class="tab1">Death of Simon I, lord of Montfort, succeeded by his son Amaury II</td>
</tr>
<tr>
<td class="tab">1089 –</td>
<td class="tab1">Death of Amaury II, succeeded by his brother Richard, who is succeeded by their brother Simon II as the lord of Montfort</td>
</tr>
<tr>
<td class="tab">1093 –</td>
<td class="tab1">Marriage of Bertrade de Montfort to King Philip I of France</td>
</tr>
<tr>
<td class="tab">1104 –</td>
<td class="tab1">Death of Simon II, succeeded by his brother Amaury III</td>
</tr>
<tr>
<td class="tab">1117 –</td>
<td class="tab1">Death of Bertrade, she is buried at Hautes-Bruyères</td>
</tr>
<tr>
<td class="tab">1119 –</td>
<td class="tab1">Amaury III becomes the count of Evreux and lord of Montfort</td>
</tr>
<tr>
<td class="tab">1129 –</td>
<td class="tab1">Bertrade’s son Fulk V of Anjou becomes the king of Jerusalem</td>
</tr>
<tr>
<td class="tab">1137 –</td>
<td class="tab1">Death of Amaury III, succeeded by his son Amaury IV</td>
</tr>
<tr>
<td class="tab">1140 –</td>
<td class="tab1">Death of Amaury IV, succeeded by his brother Simon III</td>
</tr>
<tr>
<td class="tab">1170 –</td>
<td class="tab1">Marriages of the children of Simon III in and around this year: Amaury V to Mabel, daughter of the 2nd earl of Gloucester; Simon IV to Amicia, daughter of the 3rd earl of Leicester; Bertrade to the 5th earl of Chester</td>
</tr>
<tr>
<td class="tab">1171 –</td>
<td class="tab1">Probable birth year of Simon V, his brother Guy I born sometime later</td>
</tr>
<tr>
<td class="tab">1181 –</td>
<td class="tab1">Death of Simon III, his son Amaury V becomes the count of Evreux, his other son Simon IV becomes the lord of Montfort</td>
</tr>
<tr>
<td class="tab">1185 –</td>
<td class="tab1">Death of Simon IV, succeeded by his son Simon V</td>
</tr>
<tr>
<td class="tab">1186 –</td>
<td class="tab1">Amaury V goes on crusade to the Holy Land</td>
</tr>
<tr>
<td class="tab">1188 –</td>
<td class="tab1">Amicia de Montfort marries William III des Barres</td>
</tr>
<tr>
<td class="tab">1194 –</td>
<td class="tab1">Death of Amaury V, succeeded by his son Amaury VI</td>
</tr>
<tr>
<td class="tab">1195 –</td>
<td class="tab1">Simon V marries Alice Montmorency, probable birth year of Amaury VII</td>
</tr>
<tr>
<td class="tab">1197 –</td>
<td class="tab1">Probable birth year of Guy II</td>
</tr>
<tr>
<td class="tab">1199 –</td>
<td class="tab1">Simon V and Guy I take the cross, Amaury VI becomes the 3rd earl of Gloucester</td>
</tr>
<tr>
<td class="tab"><a id="page_ix"></a>1202 –</td>
<td class="tab1">The Fourth Crusade musters in Venice, diversion to Zara</td>
</tr>
<tr>
<td class="tab">1203 –</td>
<td class="tab1">Diversion of the crusade to Constantinople, Simon V and Guy I leave for the Holy Land</td>
</tr>
<tr>
<td class="tab">1204 –</td>
<td class="tab1">Conquest of Constantinople, conquest of Normandy, death of Robert de Beaumont, 4th earl of Leicester, Guy I marries Helvis of Ibelin, becomes the lord of Sidon</td>
</tr>
<tr>
<td class="tab">1206 –</td>
<td class="tab1">Simon V returns to France</td>
</tr>
<tr>
<td class="tab">1207 –</td>
<td class="tab1">Simon V is made the 5th earl of Leicester, but stripped of the earldom by King John</td>
</tr>
<tr>
<td class="tab">1208 –</td>
<td class="tab1">Pope Innocent III launches the Albigensian crusade, probable birth year of Simon VI</td>
</tr>
<tr>
<td class="tab">1209 –</td>
<td class="tab1">Sack of Béziers, Simon V becomes crusade commander</td>
</tr>
<tr>
<td class="tab">1210 –</td>
<td class="tab1">Alice de Montfort joins the crusade, brings the children south</td>
</tr>
<tr>
<td class="tab">1211 –</td>
<td class="tab1">Simon defeats Raymond VI at Castelnaudary, the first siege of Toulouse, daughter Petronilla is born and baptised by Dominic de Guzman, Guy I joins the crusade,</td>
</tr>
<tr>
<td class="tab">1212 –</td>
<td class="tab1">Simon V elected king of England, issues the Statute of Pamiers</td>
</tr>
<tr>
<td class="tab">1213 –</td>
<td class="tab1">Simon V victorious at the battle of Muret, Amaury VI dies, Amaury VII is knighted</td>
</tr>
<tr>
<td class="tab">1214 –</td>
<td class="tab1">Amaury VII marries Beatrice of Vienne</td>
</tr>
<tr>
<td class="tab">1215 –</td>
<td class="tab1">Lateran V in Rome, Raymond VI is disinherited, Simon V becomes the count of Toulouse, death of his mother Amicia</td>
</tr>
<tr>
<td class="tab">1216 –</td>
<td class="tab1">Simon V defeated at Beaucaire, the revolt of Toulouse is crushed, Guy II marries the countess of Bigorre</td>
</tr>
<tr>
<td class="tab">1217 –</td>
<td class="tab1">The second siege of Toulouse</td>
</tr>
<tr>
<td class="tab">1218 –</td>
<td class="tab1">Simon V is killed in front of Toulouse, Amaury VII becomes the count of Toulouse and lord of Montfort, the siege is lifted</td>
</tr>
<tr>
<td class="tab">1220 –</td>
<td class="tab1">Death of Guy II outside Castelnaudary</td>
</tr>
<tr>
<td class="tab">1221 –</td>
<td class="tab1">Death of Alice de Montfort</td>
</tr>
<tr>
<td class="tab">1222 –</td>
<td class="tab1">Death of Raymond VI of Toulouse</td>
</tr>
<tr>
<td class="tab">1224 –</td>
<td class="tab1">Amaury VII cedes his rights to Louis VIII and leaves Languedoc</td>
</tr>
<tr>
<td class="tab">1226 –</td>
<td class="tab1">Louis VIII renews the Albigensian Crusade and dies later in the year</td>
</tr>
<tr>
<td class="tab">1228 –</td>
<td class="tab1">Guy I is killed in renewed fighting, succeeded as lord of La Ferté-Alais by his son Philip I</td>
</tr>
<tr>
<td class="tab"><a id="page_x"></a>1229 –</td>
<td class="tab1">The Treaty of Meaux ends the Albigensian conflict, Raymond VII is recognised as the count of Toulouse</td>
</tr>
<tr>
<td class="tab">1230 –</td>
<td class="tab1">Simon VI goes to England, Amaury VII becomes the constable of France</td>
</tr>
<tr>
<td class="tab">1231 –</td>
<td class="tab1">Simon VI is granted the earldom of Leicester</td>
</tr>
<tr>
<td class="tab">1238 –</td>
<td class="tab1">Simon VI marries Eleanor Marshal, birth of Henry de Montfort</td>
</tr>
<tr>
<td class="tab">1239 –</td>
<td class="tab1">Amaury VII and Philip I go on crusade, Simon VI disgraced by Henry III, Amaury VII is captured in Gaza</td>
</tr>
<tr>
<td class="tab">1240 –</td>
<td class="tab1">Simon VI goes on crusade, his son Simon VII is born, Philip I marries Maria of Antioch and becomes the lord of Toron</td>
</tr>
<tr>
<td class="tab">1241 –</td>
<td class="tab1">Amaury VII is freed, he dies on return journey, succeeded as the count of Montfort by his son John I</td>
</tr>
<tr>
<td class="tab">1242 –</td>
<td class="tab1">English forces are routed at Taillebourg by Louis IX, birth of Simon and Eleanor’s son Amaury VIII</td>
</tr>
<tr>
<td class="tab">1243 –</td>
<td class="tab1">Simon and Eleanor return to England</td>
</tr>
<tr>
<td class="tab">1244 –</td>
<td class="tab1">The loss of Jerusalem, destruction of the Christian army under Philip I, birth of Guy IV</td>
</tr>
<tr>
<td class="tab">1246 –</td>
<td class="tab1">Philip I becomes the lord of Tyre</td>
</tr>
<tr>
<td class="tab">1248 –</td>
<td class="tab1">Simon VI becomes the viceroy of Gascony, John I, count of Montfort, joins the crusade of Louis IX</td>
</tr>
<tr>
<td class="tab">1249 –</td>
<td class="tab1">Death and burial of John I on Cyprus, death of Raymond VII of Toulouse</td>
</tr>
<tr>
<td class="tab">1250 –</td>
<td class="tab1">Destruction of Louis’s crusade in Egypt, Philip I is imprisoned and ransomed with the army, death of Guy III on the crusade</td>
</tr>
<tr>
<td class="tab">1252 –</td>
<td class="tab1">The trial of Simon VI, birth of Richard de Montfort</td>
</tr>
<tr>
<td class="tab">1254 –</td>
<td class="tab1">Queen Eleanor of Provence summons the first elected parliament</td>
</tr>
<tr>
<td class="tab">1256 –</td>
<td class="tab1">War of St Sabas breaks out in the crusader states</td>
</tr>
<tr>
<td class="tab">1258 –</td>
<td class="tab1">The reform period begins in England, the Provisions of Oxford are enacted, birth of Eleanor de Montfort</td>
</tr>
<tr>
<td class="tab">1259 –</td>
<td class="tab1">Simon and Eleanor obstruct the passage of the Treaty of Paris</td>
</tr>
<tr>
<td class="tab">1260 –</td>
<td class="tab1">Showdown between Henry III and Simon VI over parliament, second trial of Simon VI</td>
</tr>
<tr>
<td class="tab">1261 –</td>
<td class="tab1">Henry III repudiates the Provisions of Oxford, Simon VI goes into exile</td>
</tr>
<tr>
<td class="tab">1262 –</td>
<td class="tab1">Arbitration between Henry III and Simon VI in France</td>
</tr>
<tr>
<td class="tab">1263 –</td>
<td class="tab1">Simon VI returns to make war, seizes power and loses it</td>
</tr>
<tr>
<td class="tab"><a id="page_xi"></a>1264 –</td>
<td class="tab1">Civil war in England, Simon wins the battle of Lewes, installs a constitutional monarchy</td>
</tr>
<tr>
<td class="tab">1265 –</td>
<td class="tab1">Simon VI summons parliament with the broadest sweep of representation yet, the battle of Evesham, he and his son Henry are killed, Henry III is restored to power, Eleanor and her children Amaury, Richard and Eleanor leave England</td>
</tr>
<tr>
<td class="tab">1266 –</td>
<td class="tab1">Philip II leads Charles of Anjou’s army in the conquest of Italy and Sicily, Simon VII and Guy IV escape from England, Richard de Montfort goes to Navarre and is never heard of again</td>
</tr>
<tr>
<td class="tab">1268 –</td>
<td class="tab1">Guy IV fights at the battle of Tagliacozzo, becomes the vicar-general of Tuscany</td>
</tr>
<tr>
<td class="tab">1270 –</td>
<td class="tab1">The assassination of Philip I in Tyre, succeeded by his son John II, death of Louis IX and Philip II on crusade in Tunis, John III succeeds his father Philip II as the count of Squillace</td>
</tr>
<tr>
<td class="tab">1271 –</td>
<td class="tab1">Guy IV and Simon VII murder Henry of Almain in Viterbo, Simon VII dies</td>
</tr>
<tr>
<td class="tab">1272 –</td>
<td class="tab1">Death of Henry III and Richard of Cornwall</td>
</tr>
<tr>
<td class="tab">1275 –</td>
<td class="tab1">Death of their sister Eleanor, her son Amaury and daughter Eleanor are seized and imprisoned by Edward I</td>
</tr>
<tr>
<td class="tab">1277 –</td>
<td class="tab1">John II ends the feud between Tyre and Acre</td>
</tr>
<tr>
<td class="tab">1278 –</td>
<td class="tab1">The marriage of Eleanor de Montfort to Llywelyn, she becomes the princess of Wales</td>
</tr>
<tr>
<td class="tab">1281 –</td>
<td class="tab1">Guy IV restored to favour in Italy</td>
</tr>
<tr>
<td class="tab">1282 –</td>
<td class="tab1">Amaury VIII is freed, his sister Eleanor dies in childbirth, her daughter Gwenllian is later placed in a nunnery</td>
</tr>
<tr>
<td class="tab">1283 –</td>
<td class="tab1">John II dies in Tyre, succeeded by his brother Humphrey</td>
</tr>
<tr>
<td class="tab">1284 –</td>
<td class="tab1">Humphrey de Montfort dies</td>
</tr>
<tr>
<td class="tab">1287 –</td>
<td class="tab1">Guy IV and John III are captured in battle with the Aragonese, John III is ransomed</td>
</tr>
<tr>
<td class="tab">1292 –</td>
<td class="tab1">Guy IV dies in prison, Amaury VIII has temporary wardship of his daughters</td>
</tr>
<tr>
<td class="tab">1300 –</td>
<td class="tab1">Amaury VIII and John III die</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Timeline.vue?0f869e8a